<div
  class="information"
  [ngClass]="{'edit': currentObjectService.isEditing}"
>
  @if (!currentObjectService.isEditing) {
    <div class="information__search-menu">
      <app-object-search-menu
        class="information__search-menu-content"
        [object]="operationContainer?.rootSectionsContainer?.rootObject"
        [isEditing]="currentObjectService.isEditing"
        [stylingClass]="'sp-procedure-page'"
      ></app-object-search-menu>

      @if (newLayout) {
        <div class="information__search-menu__navigation">
          <app-object-page-search-navigation
            slot="search-navigation"
            [artifactId]="artifactId"
            [searchContext]="currentSearchContext"
            (closeClick)="onCloseClick()"
          />
        </div>
      }

      <div class="information__template">
        <div class="information__template-button">
          @if (operationContainer?.contentInfo?.artifact) {
            <app-template-group-select-button
              [object]="operationContainer.contentInfo.artifact"
              [collapseOnSmallScreen]="false"
              (templateSelectorCreated)="onTemplateSelectorCreated($event)"
              (changeTemplateGroup)="onChangeTemplateGroup($event)"
              [templateGroupId]="operationContainer.contentInfo.templateGroupId"
              [disabled]="currentObjectService.isEditing"
            ></app-template-group-select-button>
          }
        </div>
      </div>
    </div>
  }

  @if (operationContainer?.selectorEnabled) {
    <app-search-view-selector
      class="information__selector"
      [selectorContainer]="operationContainer"
    ></app-search-view-selector>
  }

  @if (templateSelectorContainer.selectorEnabled) {
    <app-search-view-selector
      class="information__selector"
      [selectorContainer]="templateSelectorContainer"
    ></app-search-view-selector>
  }

  @if (showImageOrder) {
    <div class="side-selector change-img-order-selector information__change-image-order-selector">
      @if (operationContainer.rootSectionsContainer.rootObject && operationContainer.rootSectionsContainer.rootObject.$$mediaContainer?.mediaTypes.length) {
        <app-change-media-order
          [mediaContainer]="operationContainer.rootSectionsContainer.rootObject.$$mediaContainer"
          [sectionsContainer]="operationContainer.rootSectionsContainer"
          (toggleChangeMediaOrder)="onToggleChangeImageOrder()"
        ></app-change-media-order>
      }
    </div>
  }

  <div class="information__content">
    <div
      class="information__lower"
      [ngClass]="{'edit': currentObjectService.isEditing,
                  'smallScreen': smallScreen}"
    >
      @if (!currentObjectService.isEditing) {
        <div
          class="information__vertical-menu"
          [@showContentMenu]="smallScreen ? (openMenu ? 'expandMenu' : 'collapseMenu') : 'expandMenu'"
        >
          @if (loadingObjectInfo) {
            <div class="loading-operation-selector-vertical">
              <div
                class="loading-operation-selector-vertical__selected-first-menu"
                [ngClass]="{'isEditing': currentObjectService.isEditing}"
              ></div>
            </div>
          }

          @if (!loadingObjectInfo && operationContainer) {
            <app-operation-selector-vertical
              [operationContainer]="operationContainer"
              [contentList]="operationContainer.contentInfo.curListName"
              [smallScreen]="smallScreen"
              [editContent]="currentObjectService.isEditing"
              (selectOperation)="onSelectOperation($event)"
            ></app-operation-selector-vertical>
          }
        </div>
      }

      <div
        class="information__lower-content"
        [@showContentMenu]="smallScreen && openMenu ? 'pushContent' : 'pullContent'"
      >
        @if (loadingObjectInfo) {
          <div class="information__loading-content">
            <div class="information__loading-content-text-container">
              <mat-spinner
                color="accent"
                diameter="40"
              ></mat-spinner>

              <span>
                {{ 'TRANS__EDIT_FIELD_SELECT__HIERARCHY__LOADING' | translate }}
              </span>
            </div>
          </div>
        }

        @if (!loadingObjectInfo && operationContainer?.contentInfo) {
          <ng-container>
            <app-information-headline
              [openMenu]="openMenu"
              [isEditing]="currentObjectService.isEditing"
              [currentGroupOperation]="operationContainer.currentSelectedGroupOperation"
              [smallScreen]="smallScreen"
              [operationContainer]="operationContainer"
              (toggleMenu)="onToggleMenu()"
              (edit)="setEdit()"
              (objectLoad)="loadObject()">
            </app-information-headline>

            @if (operationContainer?.rootSectionsContainer?.rootObject && operationContainer?.contentInfo.curListName === 'overview') {
              <app-information-view-and-edit
                [isEditing]="currentObjectService.isEditing"
                [sectionsContainer]="operationContainer.rootSectionsContainer"
                class=""
              ></app-information-view-and-edit>
            }

            @if (operationContainer.contentInfo.curContentListSource && operationContainer?.contentInfo.curListName !== 'overview') {
              <app-object-content-list-source-array
                [contentListSource]="operationContainer.contentInfo.curContentListSource"
                (objectRefresh)="loadObject()"
                (newObjectCreated)="onNewObjectCreated($event)"
              ></app-object-content-list-source-array>
            }

            @if (operationContainer.contentInfo.curListContainer) {
              <app-object-content-list-regular
                [contentListContainer]="operationContainer.contentInfo.curListContainer"
                (objectRefresh)="loadObject()"
              ></app-object-content-list-regular>
            }

            @if (noObjectId) {
              <span>
                {{ 'TRANS__PROCEDURE__UNABLE_TO_FIND_PROCEDURE' | translate }}
              </span>
            }

            @if (!operationContainer?.rootSectionsContainer?.rootObject &&
                 !operationContainer.contentInfo.curListContainer &&
                 !operationContainer.contentInfo.curContentListSource) {
              <div>
                <span>
                  {{ 'TRANS__CONTENT_LIST__NO_CONTENT' | translate }}
                </span>
              </div>
            }
          </ng-container>
        }
      </div>
    </div>
  </div>

  @if (currentObjectService.isEditing) {
    <div class="object-page__action-toolbar">
      @if (operationContainer?.currentOperation?.$$currentStep) {
        <app-operation-toolbar
          [operationContainer]="operationContainer"
          [operationStep]="operationContainer.currentOperation.$$currentStep"
        ></app-operation-toolbar>
      }
    </div>
  }

  @if (operationContainer?.selectorEnabled || templateSelectorContainer.selectorEnabled) {
    <div
      class="overlay"
      (click)="selectorOverlay()"
      (keydown)="null"
    ></div>
  }

  @if (operationContainer?.rootSectionsContainer?.rootObject?.$$mediaContainer && showImageOrder) {
    <div
      class="overlay"
      (click)="onToggleChangeImageOrder()"
      (keydown)="null"
    ></div>
  }
</div>

